// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as ButtonPhased from "../../resources/actions/ButtonPhased.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
import * as PriceRetailTableCell from "../Price/PriceRetailTableCell.res.js";
import * as PriceRetailTableEditCell from "../Price/PriceRetailTableEditCell.res.js";
function CatalogVariantPriceRetailTableEditCellWrapper(props) {
  let dispatch = props.onRequestDispatch;
  let variantPrice = props.variantPrice;
  let __disabled = props.disabled;
  let disabled = __disabled !== undefined ? __disabled : false;
  let match = React.useState(() => false);
  let setFocused = match[1];
  let onFocus = () => setFocused(param => true);
  let onBlur = () => setFocused(param => false);
  let match$1 = Hover.use(undefined, undefined, undefined);
  let onChange = React.useCallback(price => dispatch({
    TAG: "RetailPriceUpdated",
    _0: {
      id: variantPrice.id,
      variantId: variantPrice.variantId,
      priceId: variantPrice.priceId
    },
    _1: Stdlib_Option.getOr(price, 0)
  }), [variantPrice.variantId, variantPrice.id]);
  let newrecord = {
    ...{
      style: {
        marginLeft: "-10px"
      }
    }
  };
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx("div", (newrecord.children = match[0] ? JsxRuntime.jsx(PriceRetailTableEditCell.make, {
      valueExcludingTax: variantPrice.valueExcludingTax,
      valueIncludingTax: variantPrice.valueIncludingTax,
      taxIncluded: variantPrice.taxIncluded,
      taxRate: variantPrice.taxRate,
      purchasePrice: variantPrice.purchasePrice,
      bulkUnit: variantPrice.capacityUnit,
      autoFocused: true,
      shrinkInput: true,
      onChange: onChange,
      onFocus: onFocus,
      onBlur: onBlur
    }) : JsxRuntime.jsx(ButtonPhased.make, {
      children: JsxRuntime.jsx(PriceRetailTableCell.make, {
        valueExcludingTax: variantPrice.valueExcludingTax,
        valueIncludingTax: variantPrice.valueIncludingTax,
        taxIncluded: variantPrice.taxIncluded,
        capacityUnit: variantPrice.capacityUnit
      }),
      hovered: match$1[1],
      disabled: disabled,
      onPress: () => setFocused(param => true)
    }), newrecord)),
    ref: match$1[0]
  });
}
let make = React.memo(CatalogVariantPriceRetailTableEditCellWrapper);
export { make };
/* make Not a pure module */